import React, { useState, useEffect, useMemo } from "react";
import Plot from "react-plotly.js";
import moment from "moment"

export const HeatmapPlotlyChart = ({ data, type }) => {
  // State for layout and data
  const [layout, setLayout] = useState({
    font: { color: "white" },
    margin: { t: 70, b: 70, r: 50, l: 50, pad: 8 },
    xaxis: {
      type: "category",
      side: 'top',
      autorange: "reversed",
      showgrid: false, 
      ticks:"",
      ticklabelposition: 'outside top', // Position tick labels above the axis
      automargin: true,     
    },
    yaxis: {
      tickvals: Array.from({ length: 9 }, (_, i) => i + 9),
      ticktext: Array.from({ length: 9 }, (_, i) => {
        const hour = i + 9;
        return `${hour % 12 || 12} ${hour >= 12 ? "PM" : "AM"}`;
      }),
      range: [9, 17],
      showgrid: false,
      autorange: "reversed",
      automargin:true
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    autosize: true,
    dragmode: "zoom",
    scrollZoom: true,
  });

  const [plotData, setPlotData] = useState([]);

  const [loading, setLoading] = useState(true);

  // Generate the z data points
  const generateZdataPoints = (data) => {
    const hours = Array.from({ length: 9 }, (_, i) => i + 9);

   
    const dataZ= hours.map((hour) =>
      data.uniquePeriod_Xaxis?.map((period) => {
        const dataPoint = data.aggregateData?.find(
          (d) =>
            d.AggregatedPeriod_Xaxis === period &&
            hour === d.AggregatedHour_Yaxis
        );

        return {
          entry: dataPoint ? dataPoint.AvgEntry : 0,
          exit: dataPoint ? dataPoint.AvgExit : 0,
          value: dataPoint
            ? type === 3
              ? dataPoint.AvgNoOfPeople 
              : type===4? dataPoint.AvgOccupancy: dataPoint.AvgOccupancy
            : 0,
        };
      })
    );
     return dataZ;
  };

  // Set Chart layout title
  const setChartTitle = (type) => {
    let title;
    if (type && type === 1) {
      title =
        '<span style="color:#caeaf5">Entry</span> | <span style="color:#f48477">Exit</span> Activity by Date and Hour';
    } else if (type === 2) {
      title = "<span>Peak Occupancy Distribution</span>";
    } else if (type === 3) {
      title = "<span>Number of People By Date and Hour</span>";
    } else if(type === 4){
      title = "<span>Net Entry Exit By Date and Hour</span>";
    }

    setLayout({
      ...layout,
      title,
    });
  };

  useEffect(() => {
    if (data && data.aggregateData && data.aggregateData.length) {
      const zData = generateZdataPoints(data);
      console.log("zData", zData);
      console.log("Testtt data",data)
      const transformedData = [
        {
          z: zData.map((row) =>
            row.map((cell) => (cell.value ? cell.value : null))
          ),
          x: data.uniquePeriod_Xaxis.map(date => moment(date, 'M/DD').format('MMM D')),
          y: Array.from({ length: 9 }, (_, i) => i + 9),
          text: zData.map((row) =>
            type === 1
              ? row.map(
                  (cell) =>
                    `<span style="color:#caeaf5">${cell.entry}</span> <span style="color:white">|</span> <span style="color:#f58270">${cell.exit}</span>`
                )
              : type === 2
              ? row.map(
                  (cell) =>
                    `<span style="color:black">${
                      cell.value === 0 ? "-" : `${cell.value}%`
                    }</span>`
                )
              : row.map(
                  (cell) =>
                    `<span style="color:#caeaf5">${cell.value}</span>  <span style="color:#f58270"></span>`
                )
          ),
          textfont: { size: 12, color: "#f58270" },
          type: "heatmap",
          colorscale:
            type === 1 || type === 3 || type === 4
              ? [
                  [0, "rgba(0,0,0,0)"],
                  [1, "rgba(0,0,0,0)"],
                ]
              : [
                  [0, "#f00"], // 0% to 30% -> Red
                  [0.3, "#f00"], // 30% (end of red)
                  [0.3, "#ffff00"], // 30% to 50% -> Yellow
                  [0.5, "#ffff00"], // 50% (end of yellow)
                  [0.5, "lawngreen"], // 50%+ -> Green
                  [1, "lawngreen"], // 100% (still green)
                ],
          showscale: false,
          texttemplate: "%{text}",
          hoverinfo: "none",
        },
      ];

      setChartTitle(type);
      setPlotData(transformedData);
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [data]);

  return (
    <>
      {loading  ? null : ( // Display loading indicator
        <Plot
          data={plotData}
          layout={layout}
          config={{ displaylogo: false, responsive: true }}
          useResizeHandler={true}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </>
  );
};
